import {get as _get} from 'lodash';
import initialState from '../initialstate';
import {
	GET_MESSAGE_LOG,
	SET_MESSAGE_LOG,
	SET_MESSAGE_LOG_FILTER,
	CLEAR_MESSAGE_LOG_FILTER
} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeMessageLog from './normalizeMessageLog';
import normalizeMessage from './normalizeMessage';
import filterMessages from './filterMessages';
import normalizeFilters from './normalizeFilters';

export function messageLogReducer(state = initialState.messageLog, action) {
	switch (action.type) {
		case GET_MESSAGE_LOG: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				const normalizeMessages = normalizeMessageLog(data);
				return {messages: [...normalizeMessages], displayedMessages: [...normalizeMessages], filters: {}};
			}
			return state;
		}
		case SET_MESSAGE_LOG: {
			if (state?.messages === null) return {...state};
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Created && state !== null) {
				const data = _get(action, 'meta.api.data', null);
				const userData = _get(action, 'userData', null);
				if (data === null) return {...state};
				const normalizeMessages = [...state?.messages, ...normalizeMessageLog([normalizeMessage(data, userData)])].sort(
					function(a, b) {
						return new Date(b.createdDateTime) - new Date(a.createdDateTime);
					}
				);
				return {
					messages: [...normalizeMessages],
					displayedMessages: [...normalizeMessages],
					filters: {...state?.filters}
				};
			}
			return {...state};
		}
		case SET_MESSAGE_LOG_FILTER: {
			const normalizedFilters = normalizeFilters({...action}, {...state?.filters});
			const displayedMessages = filterMessages(normalizedFilters, [...state?.messages]);

			return {
				messages: [...state?.messages],
				displayedMessages: displayedMessages,
				filters: {...normalizedFilters}
			};
		}
		case CLEAR_MESSAGE_LOG_FILTER: {
			return {
				messages: [...state?.messages],
				displayedMessages: [...state?.messages],
				filters: {}
			};
		}
		default:
			return state;
	}
}
